module.exports = __webpack_public_path__ + "static/img/we-min-app.51f1d85a.jpg";